import { ClientType } from "@usher/pe-client-front-end-lib"

export const GET_RAIN_LINKS = () => [
  { route: "", title: "Company Info" },
  { route: "company-address", title: "Company Address" },
  { route: "company-contact-details", title: "Company Contact Details" },
  { route: "documents", title: "Documents", intl_id: "pa_180" },
  { route: "add-ubo", title: "Add UBO" },
  { route: "add-representatives", title: "Add Representatives" },
  { route: "add-business-offer", title: "Add Business Officer" },
]
export const GET_LINKS = (clientType: ClientType, tab: string) => {
  let result = [
    { route: "", title: "Personal Details", intl_id: "pa_177" },
    { route: "passport", title: "ID/Passport Form", intl_id: "pa_178" },
    { route: "proof-of-address", title: "Proof of Address", intl_id: "pa_179" },
    { route: "proof-of-card", title: "Photo of payment card", intl_id: "pa_180", type: "exchange" },
    { route: "photo-with-passport", title: "Photo of a selfie with a passport in hand", intl_id: "pa_181" },
    { route: "set-your-wallet", title: "Set your wallet", intl_id: "pa_182", type: "exchange" },
    { route: "get-link", title: "Get Verification Link", intl_id: "get_verification_link", type: "bank_account" },
  ]
  if (clientType === ClientType.Coroporate)
    result = [
      { route: "", title: "Certificate of incorporation", intl_id: "verif_1" },
      { route: "amoa", title: "Articles and Memorandum of Association ", intl_id: "verif_2" },
      { route: "shareholder", title: "Shareholders registry (not older than 3 months)", intl_id: "verif_3" },
      { route: "shareholders-registry", title: "Director registry (not older than 3 months)", intl_id: "verif_4" },
      { route: "excerpt", title: "Excerpt from a state company registry", intl_id: "verif_5" },
      { route: "proof-of-address", title: "Proof of address", intl_id: "verif_6" },
      { route: "cgs", title: "Certificate of good standing (optional)", intl_id: "verif_7" },
      { route: "state-of-information", title: "Statement of information (optional)", intl_id: "verif_8" },
      { route: "bank-statement", title: "Bank statement  (not older than 1 month)", intl_id: "verif_9" },
      { route: "license", title: "License", intl_id: "verif_10" },
      { route: "ein-tax-vat", title: "EIN/Tax/VAT-EU confirmation", intl_id: "verif_11" },
      { route: "get-link", title: "Get Verification Link", intl_id: "get_verification_link", type: "bank_account" },
    ]
  return (
    result.filter((item) => {
      if (item.type == null) return true
      if (item.type === tab) return true
      return false
    }) || []
  )
}
